import { theme } from "@src/theme";
import styled from "styled-components";
import Tooltip from "./Tooltip";
import { ITrack } from "@src/types/track";
import { useAuthCurator, useRole } from "@src/hooks/useAuth";

const StyledAlsoFoundBadge = styled.div<{
  value?: string;
  $active?: boolean;
  $color: string;
}>`
  height: 14px;
  width: 14px;
  border-radius: 7px;
  background-color: ${({ $color }): string => $color};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AlsoFoundBadge = ({
  value,
  row,
}: {
  value?: string;
  row?: ITrack;
}): React.JSX.Element => {
  const curatorData = useAuthCurator();
  const role = useRole();
  const count = row?.foundInPlaylist?.length ?? 0;
  const uniqueCurators = new Set(
    row?.foundInPlaylist?.map((fip) => fip?.playedByCurator?.curatorId || "")
  );
  const uniquePlaylists = Array.from(
    new Set(row?.foundInPlaylist?.map((fip) => fip?.id))
  );
  const myUniquePlaylists = Array.from(
    new Set(
      row?.foundInPlaylist
        ?.filter((fip) => fip?.playedByCurator?.curatorId === curatorData?.id)
        .map((fip) => fip?.id)
    )
  );
  const uniqueCuratorsCount = uniqueCurators.size;
  const colorBasedOnCount = () => {
    if (count === 0) return theme.colors.gray;
    if (count === 1) return theme.colors.green;
    if (count > 1 && uniqueCuratorsCount > 1) return theme.colors.yellow;
    if (count > 1) return theme.colors.orange;
    return theme.colors.gray;
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Tooltip
        content={(() => {
          if (value === "#979794") {
            return row?.isrc ? "Not used in any playlists" : "Not found (ISRC)";
          }
          if (count === 1) {
            const playlist = row?.foundInPlaylist?.[0];
            return playlist ? `In playlist (${playlist.id})` : "";
          }
          if (count > 1) {
            if (uniqueCuratorsCount > 1) {
              return (
                <>
                  <span>
                    In ROVR Library, used ({uniquePlaylists?.length || 0}) times{" "}
                    <br />
                    {(role === "admin" || role === "manager"
                      ? uniquePlaylists
                      : myUniquePlaylists
                    )?.map((fip, index) => (
                      <span key={fip}>
                        In playlist ({fip})
                        {index < (uniquePlaylists?.length ?? 0) - 1 && <br />}
                      </span>
                    ))}
                  </span>
                </>
              );
            }
            return (
              <>
                {uniquePlaylists?.map((fip, index) => (
                  <span key={fip}>
                    In playlist ({fip})
                    {index < (uniquePlaylists?.length ?? 0) - 1 && <br />}
                  </span>
                ))}
              </>
            );
          }
          return "";
        })()}
      >
        <StyledAlsoFoundBadge $color={colorBasedOnCount()} />
      </Tooltip>
    </div>
  );
};
export default AlsoFoundBadge;
